export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';
import './index.styl'; 

import {TagProps} from 'kpc';

interface Props {
    colors: string[]
}

export default class extends Component {
    static template = template;
    static defaults() {
        return {
            colors: ['default', 'primary', 'danger', 'success', 'warning', 'purple', 'teal', 'blue', 'yellow', '#f50', '#87d068', 'rgb(255, 0, 179)'],
        } as Props;
    }
}